import request from '/@/api/http/request'

export interface pageParams {
  current: number,
  size: number
}

// 航线列表
export const waylinefilePage = async function (params: pageParams) {
  const url = '/biz/waylinefile/page'
  const result = await request.get(url, { params })
  return result.data
}

// 获取计划任务执行表分页
export const waylineJobExecutionPage = async function (params: pageParams) {
  const url = '/biz/jobexecution/page'
  const result = await request.get(url, { params })
  return result.data
}

// 获取当前登录账号信息
export const getAccountInfo = async function () {
  const url = '/manage/api/v1/workspaces/current'
  const result = await request.get(url)
  return result.data
}

// 获取默认视频
export const getVideoDefaultUrl = async function () {
  const url = '/biz/jobexecution/video/url'
  const result = await request.get(url)
  return result.data
}

export interface recognitionParams {
  id?: number,
}

// 获取最新的识别结果
export const recognitionRecord = async function (params: recognitionParams) {
  const url = '/biz/jobexecution/recognition/record'
  const result = await request.get(url, { params })
  return result.data
}

// drc心跳
export const drcHeart = async function (workspace_id: string, body: any) {
  const url = `/control/api/v1/workspaces/${workspace_id}/drc/heart`
  const result = await request.post(url, body)
  return result.data
}

// 发送指令
export const droneControl = async function (workspace_id: string, body: any) {
  const url = `/control/api/v1/workspaces/${workspace_id}/drone/control`
  const result = await request.post(url, body)
  return result.data
}

// 急停
export const emergencyStop = async function (workspace_id: string, body: any) {
  const url = `/control/api/v1/workspaces/${workspace_id}/drone/emergency/stop`
  const result = await request.post(url, body)
  return result.data
}

// 字典
export const dictTree = async function () {
  const url = '/dev/dict/tree'
  const result = await request.get(url)
  return result.data
}
